import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  AdapterConfiguration,
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}adapterEndpointConfigurations`;

export interface GetAdapterConfigurationArgs {
  sellerId: string;
}

export default async function getAdapterConfiguration(
  payload: GetAdapterConfigurationArgs,
): Promise<BackResponse<AdapterConfiguration[]> | BackResponseFailure> {
  try {
    const { sellerId } = payload;
    const url = buildUrl(ENDPOINT, {
      sellerId,
    });

    return await apiCall<BackResponse<AdapterConfiguration[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
